import { Box } from '@mui/material';
import { KitButton, SecH } from '../common/MobileKit';
import { KitField, KitFormBar, KitGrid2, KitInput } from '../common/MobileKitExtras';
import FkField from '../common/MobileFormFields';

/**
 * Formulário de maquininha no shell mobile — `prototipos-mobile/maquininhas/form.html`.
 * Só apresentação: valores, validação (Yup/Formik), matriz de taxas por parcela e envio
 * vêm de `pages/card_machines/Form.js`.
 */
export default function MobileCardMachineForm({
    formik,
    maxInstallmentLimit,
    onMaxInstallmentChange,
    installmentRates,
    onRateChange,
    onSave,
    onCancel,
    loading,
}) {
    const rates = installmentRates.slice().sort((a, b) => a.installment_number - b.installment_number);
    return (
        <Box sx={{ fontSize: 14, lineHeight: 1.4 }} component="form" onSubmit={(e) => { e.preventDefault(); onSave(); }} noValidate>
            <FkField formik={formik} name="name" label="Nome" required type="text" placeholder="Ex.: Stone Balcão" />

            <SecH title="Taxas (%)" />
            <KitGrid2>
                <FkField formik={formik} name="tax_debit" label="Débito" required type="text" inputMode="decimal" placeholder="0,00" />
                <FkField formik={formik} name="tax_pixqrcode" label="PIX" required type="text" inputMode="decimal" placeholder="0,00" />
            </KitGrid2>
            <FkField
                formik={formik}
                name="maxInstallment"
                label="Máx. parcelas"
                required
                type="number"
                inputMode="numeric"
                placeholder={`1 a ${maxInstallmentLimit}`}
                min={1}
                max={maxInstallmentLimit}
                onChange={(e) => onMaxInstallmentChange(e.target.value)}
                help={rates.length === 0 ? 'Informe o máximo de parcelas para gerar as taxas de crédito por parcela.' : undefined}
            />

            {rates.length > 0 && (
                <>
                    <SecH title="Crédito por parcela (%)" />
                    <KitGrid2>
                        {rates.map((rate) => (
                            <KitField key={rate.installment_number} label={`${rate.installment_number}x`}>
                                <KitInput
                                    type="text"
                                    inputMode="decimal"
                                    value={rate.tax}
                                    onChange={(e) => onRateChange(rate.installment_number, e.target.value)}
                                    aria-label={`Taxa de crédito em ${rate.installment_number}x`}
                                />
                            </KitField>
                        ))}
                    </KitGrid2>
                </>
            )}

            <KitFormBar>
                <KitButton onClick={onCancel}>Cancelar</KitButton>
                <KitButton variant="primary" onClick={onSave} disabled={loading}>
                    {loading ? 'Salvando...' : 'Salvar'}
                </KitButton>
            </KitFormBar>
        </Box>
    );
}
